import React from "react";
import Tag from "../common/Tag/Tag";

//TODO: This should be replaced with the proper styled component when available
const programmeStatusVariants = {
    final: "success",
    approved: "success",
    draft: "warning",
    new: "info",
    inactive: "error",
};

/**
 * Renders PMC status using the current token-backed tag without changing the
 * legacy status helper used by older AMI screens.
 */
export function RenderCareerProgrammeStatus(value) {
    const text = value ? String(value) : "N/A";
    const variant =
        programmeStatusVariants[text.trim().toLowerCase()] || "neutral";

    return {
        color: variant,
        text,
        html: <Tag variant={variant}>{text}</Tag>,
    };
}
